module.exports = __webpack_public_path__ + "static/media/remoto.0feca331.jpg";